import {state} from './state.js';

export const UPDATE_ID = (State, id) => {
    State.currentId = parseInt(id);
};

export const UPD_LOAD_ANIMATE = (State, animated) => {
    State.animatedLoad = animated;
    State.handleBlock = !animated;
};

export const UPD_UI_SHOW = (State, show) => {
    State.uiShow = show;
};
export const UPD_ANIMATED = (State, animated) => {
    State.animated = animated;
};

export const UPD_HANDLE_BLOCK = (State, blockker) => {
  State.handleBlock = blockker;
};

export const SET_POPUP = (State, popup) => {
    State.popup = popup ? popup : {name: false};
};



// WEBPACK FOOTER //
// ./src/store/mutations.js